"use client";

import React from 'react';

const isDev = process.env.NODE_ENV === 'development';

const DevModeIndicator: React.FC = () => {
    if (!isDev) return null;

    return (
        <div className="fixed bottom-4 left-4 z-[9999]">
            <div className="bg-red-600/90 text-white px-2 py-1 rounded text-xs font-bold shadow-lg backdrop-blur-sm border border-red-500/50">
                DEV MODE
            </div>
        </div>
    );
};

export default DevModeIndicator;